<template>
  <main class="historytasks-page">
    <TopBar :page-header="$t('historyTasksPage.historicalCMI')" />
    <div class="content">
      <table class="styled-table">
        <colgroup>
          <col width="21%">
          <col width="38%">
          <col width="10%">
          <col width="10%">
          <col width="12%">
          <col width="9%">
        </colgroup>
        <thead>
          <tr v-if="Object1Exists()">
            <th>{{ $t('historyTasksPage.TaskNumber') }}</th>
            <th>{{ getObject1Name() }}</th>
            <!-- <th>{{objectnaming.object1.single}}  {{ $t('historyTasksPage.Number') }}</th> -->
            <th>{{ $t('historyTasksPage.Created') }}</th>
            <th>{{ $t('historyTasksPage.Modified') }}</th>
            <th>{{ $t('historyTasksPage.Contact') }}</th>
            <th class="customWidth">
              {{ $t('historyTasksPage.Report') }}
            </th>
          </tr>
          <tr v-else>
            <th>{{ $t('historyTasksPage.TaskNumber') }}</th>
            <th>{{ $t('historyTasksPage.Name') }}</th>
            <th>{{ $t('historyTasksPage.Created') }}</th>
            <th>{{ $t('historyTasksPage.Modified') }}</th>
            <th>{{ $t('historyTasksPage.Contact') }}</th>
            <th>{{ $t('historyTasksPage.Report') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="taskdata.length == 0">
            <tr>
              <td colspan="5"
                  class="itemEmtypDataTd"
              >
                {{ $t('historyTasksPage.NothingToSee') }}
              </td>
            </tr>
          </template>
          <template v-for="item in taskdata"
                    :key="item.Id"
          >
            <tr>
              <td class="itemTd">
                {{ item.Nr }}
              </td>
              <td class="itemTd">
                {{ item.Location.Name }}
              </td>
              <!-- <td class="itemTd">{{ item.Location.Nr }}</td> -->
              <td class="itemTd">
                {{ item.InspectionCreated }}
              </td>
              <td class="itemTd">
                {{ item.InspectionModified }}
              </td>
              <td class="itemTd">
                {{ item.Contact }}
              </td>
              <td v-if="item.HasReport"
                  class="itemTd customWidth"
              >
                <span class="material-icons download"
                      @click="downloadReport(item)"
                >download_for_offline</span>
              </td>
              <td v-else
                  class="itemTd customWidth"
              >
                <span class="material-icons download"
                      @click="reportNotReady()"
                >pending</span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </main>
</template>

<script setup>
import {
    API_GetFinishedReport
  } from '../apiCalls/api.js';
import TopBar from "../components/TopBar.vue";
import { useToast } from "vue-toastification";
import i18n from '../locales/i18n'
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
  
const toast = useToast();
const store = useStore();

let taskdata = computed(() => store.state.historytasks.taskdata);
let objectnaming = computed(() => store.state.tasks.objectnaming);

console.log(taskdata);
onMounted(async () => {
  store.dispatch("historytasks/getTaskData");
  store.dispatch("tasks/getObjectNaming");
});
function reportNotReady(){
    toast.info( i18n.global.t('historyTasksPage.ReportNotReady') )
}
async function downloadReport(task){
  try{
    const downloadResponse = await API_GetFinishedReport(task.Id);
    //console.log(downloadResponse);
    const byteCharacters = window.atob(downloadResponse.data.Base64Data);
    //const byteCharacters = Buffer.from(downloadResponse.data.Base64Data, 'base64').toString('base64');
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = task.Location.Name;
    link.click()
    URL.revokeObjectURL(link.href)
  }
  catch(e){
    console.log(e);
    toast.error( i18n.global.t('historyTasksPage.ReportDownloadFailed') +"\r\n\r\n"+ e.message )
  }
  
}

function Object1Exists(){
  return objectnaming.value.object1 != null
}

function getObject1Name(){
  if(window.siteConfig?.Object1Name){
    return window.siteConfig.Object1Name[i18n.global.locale]
  }
  return objectnaming.value.object1.single 

}

</script>

<style lang="scss" scoped>
.historytasks-page {
  height: 100vh;
  overflow-y: scroll;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: linear-gradient(90deg, var(--gray) 0%, var(--background2) 10px);
  .content {
    padding: 2rem;
  }
}

.customWidth{
  text-align: center !important;
}
.styled-table {
  table-layout: fixed;
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.styled-table thead tr {
  background-color: var(--sidebar);
  color: #ffffff;
  text-align: left;
}

.styled-table th {
  padding: 12px 10px;
  text-align: left;
    text-overflow:ellipsis;
  overflow:hidden;
  white-space: nowrap;
}

.itemHeaderTd {
  padding: 12px 10px;
  text-align: left;
  font-weight: bold;
  cursor: pointer;

}
.itemTd {
  padding: 0px 8px;
  text-align: left;
  transition: padding 0.4s ease;
    word-wrap: break-word;

  .download{
    text-align: center;
    cursor: pointer;
  }
}
.itemEmtypDataTd{
    text-align: center;
    padding: 12px 15px;
    font-family: sans-serif;
    font-size: 0.9em;
        font-weight: bold;
}

.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
  background-color: var(--background2);

  .expandable {
    overflow: hidden;
    //max-height:0;
    //transition: max-height 1.0s ease;

    height: 0;
    transition: height 1s ease;

    &.is-expanded {
      //max-height: 500px;
      //transition: max-height 1.0s ease;
      height: auto;
      transition: height 1s ease;
    }
  }
}

.styled-table tbody tr:nth-of-type(2n) {
  background-color: var(--light);
}

.styled-table tbody tr:last-of-type {
  border-bottom: 3px solid var(--primary);
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: var(--sidebar);
}

@media(max-width:769px) {
      .historytasks-page .content{
        padding: 0px;
        min-width: unset;
      }
  }
</style>
